import { render, staticRenderFns } from "./tab-pane-role.vue?vue&type=template&id=7d313f9b&scoped=true"
import script from "./tab-pane-role.vue?vue&type=script&lang=js"
export * from "./tab-pane-role.vue?vue&type=script&lang=js"
import style0 from "./tab-pane-role.vue?vue&type=style&index=0&id=7d313f9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d313f9b",
  null
  
)

export default component.exports